import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import MarketOzonApi from '../../../../API/market/ozon-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { Switch } from '../../../../components/Basic/Elements';
import { DateInput, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { Table, TableHeader } from '../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import { MarketsSearch, MarketsTable } from '../../../../components/Markets';
import MarketsFilter, { FRONT_ERRORS, FRONT_WARNING } from '../../../../components/Markets/Blocks/Filter';
import { MARKET_MODES, MARKETS_MAP, TYPE_BUTTONS } from '../../../../constans';
import { numberWithSpaces } from '../../../../utils';
import styles from './styles.module.scss';

export const FILTER_MARKETPLACE = {
  0: 'allstock',
  1: 'instock',
  2: 'nullstock',
  3: 'warehousestock',
  4: 'mpstock',
  5: 'express',
  6: 'outofstock',
  7: 'stopbrand',
  8: 'errostock',
  9: 'warningstock',
  10: 'notupdatedstock',
  11: 'isminusstock',
  12: 'archivestock',
};

const SORT_TYPE = [
  { text: 'Не выбран', value: undefined },
  { text: 'Кол-во заказов', value: 'grow_sales' },
];

const OzonTable = ({
  parentUpdate,
  isFbsRemainsMode = false,
  setIsFbsRemainsMode,
  isExpress = false,
  updateProviderStocksAndPrice = () => {},
  updateProviderPrice = () => {},
  ...props
}) => {
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [error, setError] = useState(Object.keys(FRONT_ERRORS)[0]);
  const [warning, setWarning] = useState(Object.keys(FRONT_WARNING)[0]);
  const [period, setPeriod] = useState({
    start: new Date(moment().subtract(5, 'M')),
    end: new Date(moment().add(1, 'day')),
  });

  const [provider, changeProvider] = useState({ id: null, name: 'Не выбран' });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [profitStatistic, setProfitStatistic] = useState({});

  const [cards, setCards] = useState({ ids: [], byId: {} });
  const shop = useSelector((store) => store.ozon.market);
  const { role } = useSelector((store) => store.user);
  const [pricesMode, setPricesMode] = useState(true);
  const [sizesMode, setSizesMode] = useState(false);

  const [productsSelect, setProductsSelect] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [errorsGroup, setErrorsGroup] = useState({});
  const [warningsGroup, setWarningsGroup] = useState({});
  const [contentMode, changeMode] = useState(isFbsRemainsMode ? MARKET_MODES[3] : MARKET_MODES[0]);
  const [sortType, changeSortType] = useState({ text: 'Не выбран', value: undefined });

  const params = useMemo(() => {
    return {
      search: search.trim(),
      limit: parseInt(show),
      shop: MARKETS_MAP[shop],
      page,
      isFbsRemainsMode: isFbsRemainsMode,
      providerId: provider.id,
      tab: FILTER_MARKETPLACE[tab],
      filters: {
        period,
        sortType: sortType.value,
        errorType: error === 'null' ? null : error,
        warningType: warning === 'null' ? null : warning,
      },
    };
  }, [search, show, shop, page, tab, provider.id, error, warning, isFbsRemainsMode, period, sortType]);

  const params_excel = useMemo(() => {
    return {
      ...params,
      limit: undefined,
      page: undefined,
    };
  }, [params]);

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const colorByPercent = (perc) => {
    if (perc >= 90) return '#168600ff';
    if (perc >= 80) return '#56b601ff';
    if (perc >= 70) return '#99aa00ff';
    if (perc >= 60) return '#aa6c00ff';
    return '#aa0000ff';
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      cards.ids.forEach((item) => {
        map_select[cards.byId[item].offer_id] = true;
      });
      console.log(map_select);
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setProductsSelect({});
    }
  };

  const changeProductSelect = (offer_id) => {
    if (productsSelect[offer_id]) {
      const s = productsSelect;
      delete s[offer_id];
      setProductsSelect({ ...s });
    } else {
      setProductsSelect({ ...productsSelect, [offer_id]: true });
    }
  };

  let loadCards = () => {
    MarketOzonApi.getCardsBySearch({ data: params }).then((r) => {
      const {
        allstock,
        instock,
        nullstock,
        archivestock,
        outofstock,
        mpstock,
        warehousestock,
        stopbrand,
        express = 0,
        errostock = 0,
        warningstock = 0,
        minusstock,
        notupdatedstock,
      } = r.stock;

      const byIds = {};
      const id = r.cards.map((item) => item.offer_id);
      r.cards.forEach((item) => (byIds[item.offer_id] = item));
      setErrorsGroup(r.errorsGroup);
      setWarningsGroup(r.warningsGroup);
      setCards({ byId: byIds, ids: id });
      setProductsSelect({});
      setProfitStatistic(r.profitStatistic);
      const p = allProviders.filter((item) => r.providersIdsInShipments?.includes(item.id));
      setProviders([{ name: 'Не выбран', id: null }, { name: 'Не заполнен', id: -1 }, ...p] || allProviders);
      setCheckAll(false);
      setCountStock([
        allstock,
        instock,
        nullstock,
        warehousestock,
        mpstock,
        express,
        outofstock,
        stopbrand,
        errostock,
        warningstock,
        notupdatedstock,
        minusstock,
        archivestock,
      ]);
      setCount(r.stock.count);
    });
  };

  useEffect(() => {
    loadCards();
  }, [params, parentUpdate]);

  const onChangeCard = async (offer_id, key, value, skladName) => {
    if (cards.byId[offer_id][key] === value) {
      return;
    }
    let setCard = (card) => {
      setCards({ ...cards, byId: { ...cards.byId, [offer_id]: { ...cards.byId[card.offer_id], ...card } } });
    };

    if (key === 'stock') {
      return await MarketOzonApi.changeStock({
        data: { shop: MARKETS_MAP[shop], offer_id, value: parseInt(value), skladName },
      })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'price') {
      return await MarketOzonApi.changePrice({ data: { shop: MARKETS_MAP[shop], offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'percent' || key === 'min_rub') {
      return await MarketOzonApi.changeMarginality({
        data: { shop: MARKETS_MAP[shop], offer_id, field: key, value: parseInt(value) },
      })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'archive') {
      return await MarketOzonApi.changeArchive({ data: { shop: MARKETS_MAP[shop], offerIds: [offer_id], value } })
        .then((r) => {
          //    setCard(card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketOzonApi.changeStopBrand({ data: { shop: MARKETS_MAP[shop], offerIds: [offer_id], value } })
        .then((r) => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }
    return await MarketOzonApi.changeCard({ data: { shop: MARKETS_MAP[shop], offer_id, field: key, value } })
      .then((r) => {
        loadCards();
      })
      .catch((e) => console.log(e));
  };

  const onChangeCards = async (offerIds, key, value) => {
    if (key === 'archive') {
      return await MarketOzonApi.changeArchive({ data: { shop: MARKETS_MAP[shop], offerIds, value } })
        .then((r) => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketOzonApi.changeStopBrand({ data: { shop: MARKETS_MAP[shop], offerIds, value } })
        .then((r) => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }
    // if (key === 'stock') {
    //   return await updateProviderStocksAndPrice(undefined, value, offerIds).then(() => {
    //     setCheckAll(false);
    //     setProductsSelect({});
    //   });
    // }
    if (key === 'price') {
      return await updateProviderPrice(undefined, offerIds, true, isFbsRemainsMode).then(() => {
        setCheckAll(false);
        setProductsSelect({});
      });
    }
  };
  const isOwner = role === 'owner' || role === 'admin';

  // useEffect(() => {
  //   const p = allProviders.filter((item) => !item.hide);
  //   if (p.length > 0) {
  //     setProviders([{ name: 'Не выбран', id: null }, { name: 'Не заполнен', id: -1 }, ...p]);
  //     changeProvider({ name: 'Не выбран', id: null });
  //   } else {
  //     changeProvider({ name: '' });
  //   }
  // }, [allProviders]);

  useEffect(() => {
    setError(Object.keys(FRONT_ERRORS)[0]);
    setWarning(Object.keys(FRONT_WARNING)[0]);
  }, [tab]);

  return (
    <>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={
              contentMode === MARKET_MODES[3]
                ? ['Все товары', 'В продаже']
                : [
                    'Все товары',
                    'В продаже',
                    'Готовы к продаже',
                    'На складе',
                    'На складе МП',
                    'Экспресс',
                    'Выведено из ассортимента',
                    'Стоп бренды',
                    'С ошибками',
                    'Предупреждение',
                    'Не обновлено',
                    'В минус',
                    'Архив',
                  ]
            }
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />

          <div>
            <Select
              select={contentMode}
              list={MARKET_MODES}
              onSelect={(v) => {
                changeMode(v);
                setTab(0);
                setIsFbsRemainsMode(v === MARKET_MODES[3]);
              }}
              width="150px"
            />
          </div>
        </Row>
        <MarketsSearch
          market={'OZON'}
          selectTab={FILTER_MARKETPLACE[tab]}
          search={search}
          tab={tab}
          productsSelect={productsSelect}
          setSearch={setSearch}
          setCheckAll={setCheckAll}
          setProductsSelect={setProductsSelect}
          count={count}
          onArchive={(offerIds, state) => onChangeCards(offerIds, 'archive', state)}
          onStopbrand={(offerIds, state) => onChangeCards(offerIds, 'stopbrand', state)}
          updateStocks={(offerIds, state) => onChangeCards(offerIds, 'stock', state)}
          updatePrices={(offerIds) => onChangeCards(offerIds, 'price')}
        />
        <Row spaceBetween={true}>
          <Row>
            <MarketsFilter
              show={show}
              selectTab={FILTER_MARKETPLACE[tab]}
              provider={provider}
              providers={providers}
              error={error}
              setShow={setShow}
              setError={setError}
              setWarning={setWarning}
              changeProvider={changeProvider}
              errorsGroup={errorsGroup}
              warningsGroup={warningsGroup}
            />

            {contentMode === MARKET_MODES[0] && (
              <div style={{ marginLeft: '15px' }}>
                <Select
                  label="Сортировать по"
                  select={sortType}
                  valueFn={(p) => p.text}
                  list={SORT_TYPE}
                  width="200px"
                  onSelect={(v) => changeSortType(v)}
                />
              </div>
            )}
            {contentMode === MARKET_MODES[3] && (
              <Row>
                <Column style={{ marginRight: '10px' }}>
                  <InputLabel>Начало периода</InputLabel>
                  <Row style={{ width: '130px' }}>
                    <DateInput
                      value={period.start}
                      className={styles.calendar}
                      onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                    />
                  </Row>
                </Column>
                <Column style={{ marginRight: '10px' }}>
                  <InputLabel>Конец периода</InputLabel>
                  <Row style={{ width: '130px' }}>
                    <DateInput
                      value={period.end}
                      className={styles.calendar}
                      onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                    />
                  </Row>
                </Column>
              </Row>
            )}
          </Row>

          {contentMode === MARKET_MODES[3] ? (
            <Row>
              <Row style={{ width: '180px', marginRight: '5px' }}>
                <TextGrey style={{ marginRight: '10px' }}>Показать цены</TextGrey>
                <Switch switched={pricesMode} onClick={(v) => setPricesMode(v)} />
              </Row>
              <Row style={{ width: '200px', marginRight: '5px' }}>
                <TextGrey style={{ marginRight: '10px' }}>Показать габариты</TextGrey>
                <Switch switched={sizesMode} onClick={(v) => setSizesMode(v)} />
              </Row>
            </Row>
          ) : (
            <Column className={styles.column_button}>
              <Row>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => MarketOzonApi.excelPrices({ data: params_excel })}
                  style={{ marginRight: '15px' }}
                >
                  Скачать цены
                </Button>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => MarketOzonApi.excelData({ data: params_excel })}
                  style={{ marginRight: '15px' }}
                >
                  Скачать данные
                </Button>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => MarketOzonApi.excelAnalitycs({ data: params_excel })}
                  style={{ marginRight: '15px' }}
                >
                  Скачать аналитику
                </Button>
              </Row>
            </Column>
          )}
        </Row>
      </WhiteBlock>
      {isOwner && contentMode === MARKET_MODES[3] && (
        <Table style={{ overflow: 'auto', minHeight: 'max-content' }}>
          <TableHeader whiteHeader>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Итоговая прибыль по отчету: </TextGrey>
              <Text
                fontSize={'19px'}
                style={{ color: profitStatistic?.total_profit_by_report > 0 ? '#01800eca' : '#6e0000d9' }}
                className={styles.profit}
              >
                {numberWithSpaces(Math.ceil(profitStatistic?.total_profit_by_report))} руб. -{' '}
                {numberWithSpaces(Math.ceil(profitStatistic?.total_count_by_report))} заказов
              </Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>В пути (без отчета): </TextGrey>
              <Text style={{ color: '#70942cc5' }} className={styles.profit}>
                {numberWithSpaces(Math.ceil(profitStatistic?.total_profit - profitStatistic?.total_profit_by_report))}{' '}
                руб. -{' '}
                {numberWithSpaces(Math.ceil(profitStatistic?.total_count - profitStatistic?.sold_count_by_report))}{' '}
                заказов
              </Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Реализованная закупка / всего:</TextGrey>
              <Text style={{ color: '#603b01c3' }} className={styles.profit}>
                {numberWithSpaces(Math.ceil(profitStatistic?.total_purchase_by_report))} руб. /{' '}
                {numberWithSpaces(Math.ceil(profitStatistic?.total_purchase))} руб.
              </Text>
            </Row>
            {/* <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Всего закупка: </TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.total_purchase))} руб.</Text>
                    </Row> */}
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Процент выкупа: </TextGrey>
              <Text
                fontSize={'20px'}
                style={{
                  color: colorByPercent(
                    (profitStatistic?.sold_count_by_report * 100) / profitStatistic?.total_count_by_report,
                  ),
                }}
                className={styles.profit}
              >
                {+((profitStatistic?.sold_count_by_report * 100) / profitStatistic?.total_count_by_report).toFixed(2) ||
                  '-'}{' '}
                %
              </Text>
            </Row>

            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Маржинальность: </TextGrey>
              <Text fontSize={'20px'} style={{ color: '#838f01ad' }} className={styles.profit}>
                {+((profitStatistic?.total_profit_by_report * 100) / profitStatistic?.total_purchase_by_report).toFixed(
                  2,
                ) || '-'}{' '}
                %
              </Text>
            </Row>
          </TableHeader>
          <TableHeader whiteHeader>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Отмены по отчету: </TextGrey>
              <Text style={{ color: '#6e0000bd' }} className={styles.profit}>
                {numberWithSpaces(Math.ceil(profitStatistic?.cancel_profit_by_report))} руб. (
                {numberWithSpaces(Math.ceil(profitStatistic?.cancel_profit))} руб.) -{' '}
                {numberWithSpaces(Math.ceil(profitStatistic?.cancel_count_by_report))} заказов
              </Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Закупка бракованого товара: </TextGrey>
              <Text style={{ color: '#6e0000bd' }} className={styles.profit}>
                -{numberWithSpaces(Math.ceil(profitStatistic?.cancel_return_pvz_purchase_by_report))} руб.
              </Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Возврат заблокированного товара: </TextGrey>
              <Text style={{ color: '#950202c3' }} className={styles.profit}>
                -{numberWithSpaces(Math.ceil(profitStatistic?.total_return_blocked))} руб.
              </Text>
            </Row>
            {/* <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Доступный заработок: </TextGrey>
              <Text style={{ color: '#6a6e00bd' }} className={styles.profit}>{numberWithSpaces(Math.ceil(potentialProfit))} руб.</Text>
            </Row> */}
          </TableHeader>
          {/* <TableHeader whiteHeader>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Хранение всего: </TextGrey>
              <Text style={{ color: '#603b01c3' }} className={styles.profit}>-{numberWithSpaces(Math.ceil(storageStatistic?.total_storage))} руб.</Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Хранение сегодня: </TextGrey>
              <Text style={{ color: '#603b01c3' }} className={styles.profit}>-{numberWithSpaces(Math.ceil(storageStatistic?.total_storage_today))} руб.</Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Хранение в пвз: </TextGrey>
              <Text style={{ color: '#950202c3' }} className={styles.profit}>-{numberWithSpaces(Math.ceil(profitStatistic?.cancel_pvz_storage_by_report))} руб.</Text>
            </Row>
          </TableHeader> */}
        </Table>
      )}
      <MarketsTable
        market={'OZON'}
        pricesMode={pricesMode}
        sizesMode={sizesMode}
        contentMode={contentMode}
        checkAll={checkAll}
        clickCheckAll={clickCheckAll}
        tab={tab}
        isExpress={isExpress}
        isOwner={isOwner}
        cards={cards}
        count={count}
        show={show}
        page={page}
        selectTab={FILTER_MARKETPLACE[tab]}
        productsSelect={productsSelect}
        onChangePage={onChangePage}
        changeProductSelect={changeProductSelect}
        onChangeProduct={onChangeCard}
      />
    </>
  );
};

export default OzonTable;
